import Sprite from "app/components/sprite";
import { useAnimation } from "app/hooks/useAnimation";
import { useI18nLanguage } from "app/hooks/i18n";
import backButtonImg from "app/images/collections/back-button.png";
import backToSchoolImgAr from "app/images/collections/back-to-school-ar.png";
import backToSchoolImg from "app/images/collections/back-to-school.png";
import eidCollectionsImgAr from "app/images/collections/eid-collections-ar.png";
import eidCollectionsImg from "app/images/collections/eid-collections.png";
import healthCakesImgAr from "app/images/collections/healthy-cakes-ar.png";
import healthCakesImg from "app/images/collections/healthy-cakes.png";
import imessageIcon from "app/images/collections/imessage.png";
import messengerIcon from "app/images/collections/messenger.png";
import sweetDreamsImgAr from "app/images/collections/sweet-dreams-ar.png";
import sweetDreamsImg from "app/images/collections/sweet-dreams.png";
import telegramIcon from "app/images/collections/telegram.png";
import whatsappIcon from "app/images/collections/whatsapp.png";
import { useRef } from "react";
import { Trans } from "react-i18next";

export const WhatIsItSection = () => {
  const { locale: language } = useI18nLanguage();
  const body = useRef(null);
  const vector = useRef(null);
  const bigImage1 = useRef(null);
  const bigImage2 = useRef(null);
  const bigImage3 = useRef(null);
  const bigImage4 = useRef(null);
  const backButton = useRef(null);
  const imessage = useRef(null);
  const telegram = useRef(null);
  const whatsapp = useRef(null);
  const messenger = useRef(null);
  const smallVector1 = useRef(null);
  const smallVector2 = useRef(null);

  useAnimation([
    body,
    vector,
    bigImage1,
    bigImage2,
    bigImage3,
    bigImage4,
    backButton,
    imessage,
    telegram,
    whatsapp,
    messenger,
    smallVector1,
    smallVector2,
  ]);

  return (
    <section className="relative z-10 h-full overflow-hidden bg-white font-montserrat lg:h-[580px]">
      <div className="zbooni-layout h-full">
        <div className="mx-auto flex h-full max-w-sm flex-col-reverse gap-8 py-7 md:max-w-none md:gap-0 md:py-14 ltr:md:flex-row rtl:md:flex-row-reverse">
          <div className="relative -left-20 -top-20 z-10 m-auto h-[200px] w-full scale-50 md:top-auto md:h-[460px] md:flex-1 md:scale-[60%] lg:scale-[80%] xl:left-auto xl:scale-100">
            <img
              alt=""
              ref={bigImage1}
              data-animation="animate__animated animate__fadeInLeftBig"
              src={language == "ar" ? sweetDreamsImgAr : sweetDreamsImg}
              className="absolute left-0 top-[106px]"
            />
            <img
              alt=""
              ref={bigImage2}
              data-animation="animate__animated animate__fadeInLeftBig"
              src={language == "ar" ? eidCollectionsImgAr : eidCollectionsImg}
              className="absolute left-48 top-0"
            />
            <img
              alt=""
              ref={bigImage3}
              data-animation="animate__animated animate__fadeInLeftBig"
              src={language == "ar" ? backToSchoolImgAr : backToSchoolImg}
              className="absolute left-9 top-64"
            />
            <img
              alt=""
              ref={bigImage4}
              data-animation="animate__animated animate__fadeInLeftBig"
              src={language == "ar" ? healthCakesImgAr : healthCakesImg}
              className="absolute left-[17rem] top-64"
            />
            <img
              alt=""
              ref={backButton}
              data-animation="animate__animated animate__fadeIn animate__delay-5s"
              src={backButtonImg}
              className="absolute left-[33rem] top-56"
            />
            <img
              alt=""
              ref={imessage}
              data-animation="animate__animated animate__fadeIn animate__delay-3s"
              src={imessageIcon}
              className="absolute left-72 top-[26rem]"
            />
            <img
              alt=""
              ref={telegram}
              data-animation="animate__animated animate__fadeIn animate__delay-4s"
              src={telegramIcon}
              className="absolute left-[30rem] top-[22rem]"
            />
            <img
              alt=""
              ref={whatsapp}
              data-animation="animate__animated animate__fadeIn animate__delay-2s"
              src={whatsappIcon}
              className="absolute left-[34rem] top-24"
            />
            <img
              alt=""
              ref={messenger}
              data-animation="animate__animated animate__fadeIn animate__delay-1s"
              src={messengerIcon}
              className="absolute left-24 top-10"
            />
            <Sprite
              svgRef={smallVector1}
              dataAnimation="animate__animated animate__fadeIn animate__delay-6s"
              name="small-less-than"
              className="absolute left-8 top-4 h-5 w-6"
            />
            <Sprite
              svgRef={smallVector2}
              dataAnimation="animate__animated animate__fadeIn animate__delay-7s"
              name="small-zigzag"
              className="absolute left-0 top-[28rem] h-5 w-10"
            />
          </div>
          <div className="relative flex flex-1 items-center">
            <Sprite
              svgRef={vector}
              dataAnimation="animate__animated animate__fadeInRight"
              name="double-dome-left"
              className="absolute -right-12 -top-4 h-[205px] w-[200px] md:-right-28 md:top-8 md:h-[420px] md:w-[408px]"
            />
            <div
              ref={body}
              data-animation="animate__animated fade-in-slide-down"
              className="z-10 flex flex-1 flex-col justify-center gap-2 md:gap-4 md:pl-5 lg:pl-10 xl:pl-20"
            >
              <p className="text-[35px] font-extrabold leading-[42px] lg:text-[45px] lg:leading-[54px]">
                <Trans>What is it?</Trans>
              </p>
              <p className="max-w-sm pb-4 text-sm font-medium leading-4 md:pb-0 md:text-base md:leading-5 lg:text-lg">
                <Trans>
                  ‘Collections’ is a new and powerful marketing tool in your
                  Zbooni app that will help you sell more and gain more control
                  over your business. You can now create a collection of items
                  that you can promote where your customers are paying the most
                  attention: WhatsApp.
                </Trans>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
